module.exports = __webpack_public_path__ + "static/bsas002-f6391ec0b816dee9795c46a1f61ffce6.jpg";